var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLiteratureIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_290",
    "data-name": "Group 290",
    xmlns: "http://www.w3.org/2000/svg",
    width: 122.758,
    height: 104.512,
    viewBox: "0 0 122.758 104.512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_288",
    "data-name": "Group 288",
    transform: "translate(30.348 7.286)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_263",
    "data-name": "Group 263",
    transform: "translate(2.298)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_261",
    "data-name": "Group 261",
    transform: "translate(0.641 0.64)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_38",
    "data-name": "Line 38",
    x1: 21.398,
    y2: 12.353,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_262",
    "data-name": "Group 262"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_110",
    "data-name": "Path 110",
    d: "M2587.28,1382.812a.64.64,0,0,1-.32-1.195l21.4-12.353a.64.64,0,1,1,.64,1.108l-21.4,12.353A.63.63,0,0,1,2587.28,1382.812Z",
    transform: "translate(-2586.64 -1369.178)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_266",
    "data-name": "Group 266",
    transform: "translate(5.867 5.282)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_264",
    "data-name": "Group 264",
    transform: "translate(0.64 0.64)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_39",
    "data-name": "Line 39",
    x1: 26.917,
    y2: 15.539,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_265",
    "data-name": "Group 265"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_111",
    "data-name": "Path 111",
    d: "M2597.592,1401.26a.64.64,0,0,1-.32-1.194l26.917-15.539a.64.64,0,1,1,.64,1.108l-26.917,15.539A.629.629,0,0,1,2597.592,1401.26Z",
    transform: "translate(-2596.952 -1384.44)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_269",
    "data-name": "Group 269",
    transform: "translate(0 20.477)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_267",
    "data-name": "Group 267",
    transform: "translate(0.639 0.639)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_40",
    "data-name": "Line 40",
    x1: 24.661,
    y2: 14.223,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_268",
    "data-name": "Group 268"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_112",
    "data-name": "Path 112",
    d: "M2580.639,1443.847a.64.64,0,0,1-.32-1.2l24.661-14.223a.641.641,0,0,1,.64,1.111l-24.662,14.222A.64.64,0,0,1,2580.639,1443.847Z",
    transform: "translate(-2579.999 -1428.345)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_272",
    "data-name": "Group 272",
    transform: "translate(34.63 10.564)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_270",
    "data-name": "Group 270",
    transform: "translate(0.639 0.641)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_41",
    "data-name": "Line 41",
    x1: 7.217,
    y2: 4.162,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_271",
    "data-name": "Group 271"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_113",
    "data-name": "Path 113",
    d: "M2680.7,1405.145a.64.64,0,0,1-.32-1.194l7.215-4.163a.64.64,0,1,1,.64,1.108l-7.215,4.163A.628.628,0,0,1,2680.7,1405.145Z",
    transform: "translate(-2680.06 -1399.702)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_275",
    "data-name": "Group 275",
    transform: "translate(9.086 15.821)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_273",
    "data-name": "Group 273",
    transform: "translate(0.64 0.642)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_42",
    "data-name": "Line 42",
    x1: 41.847,
    y2: 24.158,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_274",
    "data-name": "Group 274"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_114",
    "data-name": "Path 114",
    d: "M2606.892,1440.332a.64.64,0,0,1-.32-1.194l41.847-24.159a.64.64,0,1,1,.64,1.108l-41.847,24.159A.627.627,0,0,1,2606.892,1440.332Z",
    transform: "translate(-2606.252 -1414.892)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_278",
    "data-name": "Group 278",
    transform: "translate(37.368 21.114)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_276",
    "data-name": "Group 276",
    transform: "translate(0.641 0.631)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    "data-name": "Path 115",
    d: "M2689.825,1445.078l22.626-13.069h.024",
    transform: "translate(-2689.825 -1432.009)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_277",
    "data-name": "Group 277"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_116",
    "data-name": "Path 116",
    d: "M2688.613,1444.526a.64.64,0,0,1-.32-1.194l22.625-13.07a.669.669,0,0,1,.973.554.635.635,0,0,1-.423.606l-22.536,13.017A.626.626,0,0,1,2688.613,1444.526Z",
    transform: "translate(-2687.973 -1430.185)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_281",
    "data-name": "Group 281",
    transform: "translate(18.172 39.98)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_279",
    "data-name": "Group 279",
    transform: "translate(0.641 0.641)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_43",
    "data-name": "Line 43",
    y1: 5.282,
    x2: 9.145,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_280",
    "data-name": "Group 280"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_117",
    "data-name": "Path 117",
    d: "M2633.145,1491.26a.64.64,0,0,1-.32-1.194l9.146-5.282a.64.64,0,1,1,.64,1.108l-9.146,5.282A.63.63,0,0,1,2633.145,1491.26Z",
    transform: "translate(-2632.505 -1484.697)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_284",
    "data-name": "Group 284",
    transform: "translate(27.26 26.396)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_282",
    "data-name": "Group 282",
    transform: "translate(0.639 0.632)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_118",
    "data-name": "Path 118",
    d: "M2660.612,1471.43l41.823-24.158h.024",
    transform: "translate(-2660.612 -1447.272)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_283",
    "data-name": "Group 283"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_119",
    "data-name": "Path 119",
    d: "M2659.4,1470.877a.64.64,0,0,1-.32-1.194l41.822-24.159a.669.669,0,0,1,.973.554.638.638,0,0,1-.417.6l-41.737,24.108A.628.628,0,0,1,2659.4,1470.877Z",
    transform: "translate(-2658.765 -1445.447)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_287",
    "data-name": "Group 287",
    transform: "translate(36.32 31.669)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_285",
    "data-name": "Group 285",
    transform: "translate(0.641 0.641)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_44",
    "data-name": "Line 44",
    x1: 41.847,
    y2: 24.158,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_286",
    "data-name": "Group 286"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_120",
    "data-name": "Path 120",
    d: "M2685.585,1486.122a.64.64,0,0,1-.32-1.194l41.847-24.159a.64.64,0,1,1,.641,1.108l-41.847,24.158A.627.627,0,0,1,2685.585,1486.122Z",
    transform: "translate(-2684.945 -1460.683)",
    fill: "#fff"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_289",
    "data-name": "Group 289"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_121",
    "data-name": "Path 121",
    d: "M2615.056,1414.2a2.786,2.786,0,0,1,0-4.943l-.026-7.606a.088.088,0,0,0,.026-.051,2.795,2.795,0,0,1,.01-4.943v0l-.025-7.584c0-.021.01-.04.01-.061a3.268,3.268,0,0,0-1.874-2.744l-25.716-14.944a.641.641,0,0,0-.646,1.108l25.717,14.944a2.079,2.079,0,0,1,1.234,1.616c0,.006-.007.01-.007.016a2.079,2.079,0,0,1-1.252,1.652l-35.6,20.558-11.224,6.48c-.068.039-.16.052-.231.088a7.7,7.7,0,0,1-6.7-.09l-42.948-24.95-20.957-12.179a2.886,2.886,0,0,1-1.01-.914,1.407,1.407,0,0,1-.245-.728v-.014a2.1,2.1,0,0,1,1.264-1.641l46.824-27.035a7.8,7.8,0,0,1,6.96.009l23.033,13.385a.641.641,0,0,0,.645-1.108l-23.033-13.385a8.97,8.97,0,0,0-8.245-.009l-46.824,27.035a3.285,3.285,0,0,0-1.9,2.754h0v.011l.023,7.638a2.8,2.8,0,0,1-.02,4.945l.025,7.657a3.038,3.038,0,0,0,1.484,2.453,3.094,3.094,0,0,0-1.509,2.464v.026l.025,7.631a3.287,3.287,0,0,0,1.9,2.766l63.869,37.133a9.008,9.008,0,0,0,8.246,0l21.434-12.369a.661.661,0,0,0,.231-.9.631.631,0,0,0-.871-.231l-21.435,12.4a7.924,7.924,0,0,1-6.966,0l-63.869-37.133c-.819-.486-1.255-1.05-1.255-1.665l-.025-5.3a3.676,3.676,0,0,0,.614.41c.333.193,46.35,26.922,63.9,37.133a9.531,9.531,0,0,0,8.221,0c20.564-11.883,32.062-18.515,45.814-26.454.025,0,.051-.025.077-.025h-.051a.194.194,0,0,0,.1-.051.731.731,0,0,1,.154-.077c.179-.1.41-.256.743-.435.026,0,.461-.307.615-.41v5.3a2.05,2.05,0,0,1-1.255,1.665l-15.417,8.886a.662.662,0,0,0-.23.9.637.637,0,0,0,.87.23l15.417-8.912a3.255,3.255,0,0,0,1.895-2.766v-.128C2615.056,1421.266,2615.082,1419.6,2615.056,1414.2ZM2493.6,1381.267a5.069,5.069,0,0,0,.6.405l14.084,8.182,49.811,28.948a7.043,7.043,0,0,0,1.292.5,8.929,8.929,0,0,0,6.944-.5l13.733-7.93,33.089-19.1c.032-.019.471-.305.618-.42l.017,5.31a2.085,2.085,0,0,1-1.252,1.651l-46.822,27.036a7.775,7.775,0,0,1-6.96,0l-63.885-37.127a2.085,2.085,0,0,1-1.253-1.656Zm1.25,8.6.157-.091,63.1,36.672a8.3,8.3,0,0,0,4.116,1.009,8.4,8.4,0,0,0,4.129-1.008l46.024-26.576.146.085a2.127,2.127,0,0,1,1.255,1.613.025.025,0,0,1-.026.026,2.051,2.051,0,0,1-1.255,1.639c-.256.154-46.557,26.89-46.813,27.043a7.778,7.778,0,0,1-6.94,0c-.026-.025-.051-.025-.077-.051l-.025-.025a.2.2,0,0,1-.1-.051.193.193,0,0,1-.1-.052c-.026-.026-.077-.051-.1-.076-.026,0-.052-.026-.077-.026l-.051-.051a.523.523,0,0,1-.205-.1l-.153-.077c-3.2-1.87-16.492-9.629-63-36.621C2493.157,1392.174,2493.182,1390.816,2494.847,1389.869Zm117.648,25.968c-7.632,4.4,12.139-6.991-46.813,27.043a7.7,7.7,0,0,1-6.94,0c-.256-.255-63.638-36.984-63.895-37.133-1.665-.974-1.69-2.33,0-3.3l.157-.089,28.551,16.607a.632.632,0,0,0,.87-.231c.615-1.076.052-.384-29.552-17.927a2.05,2.05,0,0,1-1.255-1.664l-.025-5.275a6.389,6.389,0,0,0,.614.41c50.066,29.092,60.719,35.29,62.615,36.391l.077.026a.025.025,0,0,0,.026.025l.052.026a.025.025,0,0,1,.025.026l.1.051c.179.1.487.281,1,.563a9.174,9.174,0,0,0,8.221,0c.256-.128,46.2-26.659,46.916-27.094.179-.1.359-.23.538-.359v5.327a2.051,2.051,0,0,1-1.255,1.639l-46.813,27.043a7.756,7.756,0,0,1-6.966,0l-21.563-12.523a.637.637,0,1,0-.64,1.1l21.563,12.523a8.859,8.859,0,0,0,8.246,0l46.006-26.577.167.1C2614.237,1413.531,2614.134,1414.914,2612.5,1415.836Z",
    transform: "translate(-2492.309 -1348.125)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122",
    "data-name": "Path 122",
    d: "M2554.343,1416.641c0,.115.076.212.231.3a.986.986,0,0,0,.509.129,1.1,1.1,0,0,0,.51-.129l2.2-1.269,2.185,1.269a.937.937,0,0,0,.519.122,1.035,1.035,0,0,0,.521-.122.378.378,0,0,0,.223-.308c0-.116-.076-.211-.22-.295l-2.184-1.27,2.188-1.263a.422.422,0,0,0,.234-.3.388.388,0,0,0-.219-.295,1.092,1.092,0,0,0-.52-.135,1.038,1.038,0,0,0-.521.135l-2.188,1.263-2.185-1.27a1,1,0,0,0-.52-.135,1.038,1.038,0,0,0-.521.135c-.144.083-.222.18-.223.3s.065.218.219.308l2.185,1.269-2.2,1.27C2554.422,1416.43,2554.343,1416.526,2554.343,1416.641Z",
    transform: "translate(-2532.874 -1390.593)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123",
    "data-name": "Path 123",
    d: "M2550.118,1431.8a2.5,2.5,0,0,0,.749.038,1.713,1.713,0,0,0,.653-.208.622.622,0,0,0,.378-.519.645.645,0,0,0-.388-.51l-.488-.17-16.845-3.956a3.292,3.292,0,0,0-1.01-.075,2,2,0,0,0-.93.274l-.2.113a.831.831,0,0,0-.475.538.868.868,0,0,0,.127.585l6.773,9.77.292.284a1.769,1.769,0,0,0,.879.226,1.8,1.8,0,0,0,.914-.226.719.719,0,0,0,.344-.368.421.421,0,0,0-.062-.434l-1.779-2.53,6.72-3.88Zm-12,1.492-3.7-5.24,9.033,2.162Z",
    transform: "translate(-2517.971 -1399.3)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiteratureIcon);
export default __webpack_public_path__ + "static/media/literature-icon.4878016e3c20630d2c419650d3bc527e.svg";
export { ForwardRef as ReactComponent };